import FirestoreDataComponent from './getFirestoreCollection'

function App() {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "column" }}>
      <FirestoreDataComponent />
    </div>
  );
}

export default App;
